import React, { createContext, useContext } from 'react';
import { app, db, analytics } from '../firebaseConfig';

const FirebaseContext = createContext(null);

export const useFirebase = () => {
    return useContext(FirebaseContext);
};

export const FirebaseProvider = ({ children }) => {
    const value = {
        app,
        db,
        analytics
    };

    return (
        <FirebaseContext.Provider value={value}>
            {children}
        </FirebaseContext.Provider>
    );
};
